import React, { useState, useEffect } from 'react';
import Promo from '../../../../class/Promo/Promo.js';
import AuthService from '../../../../class/services/AuthService.js';

import ModalPromotions from '../../modal/modalPromotions.js';
import ModalAllPromotions from '../../modal/modal_all_promotion';

const PromoHome = ({ isLogged, setIsLogged,lang }) => {
    const [promotions, setPromotions] = useState([]);
    const [modalOpen, setModalOpen] = useState(false);
    const [allModalOpen, setAllModalOpen] = useState(false);

    const [contentId, setContentId] = useState('1');
   
    const [currency, setCurrency] = useState(AuthService.getCustom('currency')); 

    useEffect(() => {
        async function fetchPromotions() {
            try {
                let promoData;
                if (isLogged) {
                    promoData = await Promo.getPromoHomeLogged(currency, AuthService.getCustom('user_id'));
                } else {
                    promoData = await Promo.getPromoHome(currency);
                }

               
                const parsedPromotions = promoData.data.map(promo => ({
                    ...promo,
                    title: JSON.parse(promo.title),  
                    img: JSON.parse(promo.img)      
                }));

                setPromotions(parsedPromotions);
            } catch (error) {
                console.error('Error fetching promotions:', error);
            }
        }

        fetchPromotions();
    }, [isLogged, lang]); 

  
    const getPromoTitle = (title) => {
        if (title && typeof title === 'object') {
            return title[lang] || title['en']; 
        }
        return title;
    };

    const openModal = (contentId) => {
        setContentId(contentId);
        setModalOpen(true);
    };

    const closeModal = () => {
        setModalOpen(false);
    };
    
    
    if (promotions.length === 0) return null;

    return (
      <>
        {modalOpen && (
          <ModalPromotions 
            isOpen={modalOpen} 
            onClose={closeModal} 
            content_id={contentId} 
            lang={lang}
          />
        )}
        <ModalAllPromotions
          show={allModalOpen}
          onClose={() => setAllModalOpen(false)}
          lang={lang}
        />
    
        <div className='container-fluid promotion-home'>
          <div className='body main-layout-item promotion_box ColumnSection_list'>
            <div className='Home_root'>
              <div className='Home_games'>
                <div className='Home_header'>
                  <a href='#' className='HomeSection_header'>
                    <img
                      alt='Promotion'
                      src='assets/img/promotion-icon.png'
                      className='HomeSection_icon'
                    />
                    <div className='HomeSection_label'>Promotion</div>
                    <div className='HomeSection_right'>
                      <div className="HomeSection_headerLink" onClick={() => setAllModalOpen(true)}>
                        Tutti
                      </div>
                      <div className='HomeSection_caption'>{promotions.length} Promozioni</div>
                    </div>
                  </a>
                </div>
    
                <div className='HomeSectionCasinoGames_list '>
                  {promotions.map((promo) => (
                    <div className='HomeSectionCasinoGames_game' key={promo.content_id} onClick={() => openModal(promo.content_id)} >
                      <div className='CasinoGameCard_root'>
                        <div className='CasinoGamePreview_root'>
                          <div className='CasinoGamePreview_gradient'></div>
                          <img
                            className='ResponsivePicture_img CasinoGamePreview_image'
                            src={promo.img.logo}
                            loading='lazy'
                            alt={getPromoTitle(promo.title)} 
                          />
                        </div>
                        <div className='title-boxPromotions'>
                          <a href='#'>{getPromoTitle(promo.title)}</a> 
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
    
              </div>
            </div>
          </div>
        </div>
      </>
    );
};

export default PromoHome;
